// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module__container___34X_b","lastCard":"index-module__lastCard___14o3B","spinnerContainer":"index-module__spinnerContainer___1vfh2"};